module.exports = __webpack_public_path__ + "img/1440.a0b002bf.jpg";